"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasWaitlistUnitConflict = hasWaitlistUnitConflict;
function hasWaitlistUnitConflict({ isWaitlistEnabled, isOnAnyWaitlist, floorPlan, unit, leaseTerm, }) {
    return Boolean(isWaitlistEnabled && isOnAnyWaitlist && (floorPlan || unit || leaseTerm));
}
